import React, { Fragment } from 'react';
import { MDBBtn,MDBIcon,MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter,MDBInput,MDBListGroup, MDBListGroupItem, MDBContainer } from "mdbreact";
import 'font-awesome/css/font-awesome.min.css';
import Fab from '@material-ui/core/Fab';

export default class History extends React.Component {

    constructor(props) {
        super(props);
        this.props = {

        }       
    }

    componentDidMount() {
        console.log("component did mount");
    }

    render() {
        return <div>History</div>
    }


}


// WEBPACK FOOTER //
// ./src/container/History/index.js